import { createSlice } from "@reduxjs/toolkit";

const intialAdminDashboardState = {
  adminDashboardDetails: {},
  adminDashboardLoader: false,
  engagementMetrics: {},
  engagementMetricsLoader: false,
  postSubscriptionMetrics: {},
  postSubscriptionMetricsLoader: false,
  propertyProductionMetrics: {},
  propertyProductionMetricsLoader: false,
  subscriptionRevenueMetrics: {},
  subscriptionRevenueMetricsLoader: false,
  customerExperienceMetrics: {},
  customerExperienceMetricsLoader: false,
  subscriptionModuleFilterData: {},
  usersModuleFilterData: {},
  propertiesFilterData: {},
  monitoringPropertiesFilterData: {},
};

const adminDashboard = createSlice({
  name: "adminDashboardDetails",
  initialState: intialAdminDashboardState,
  reducers: {
    getAdminDashboardData: (state, action) => {
      state.adminDashboardLoader = true;
      console.log("AdminDashboard slice", action.payload);
    },
    fetchAdminDashboardData: (state, action) => {
      console.log("AdminDashboard slice", action.payload);
      state.adminDashboardLoader = false;
      state.adminDashboardDetails = action.payload;
    },
    getEngagementMetrics: (state) => {
      state.engagementMetricsLoader = true;
    },
    fetchEngagementMetrics: (state, action) => {
      state.engagementMetricsLoader = false;
      state.engagementMetrics = action.payload;
    },
    getPostSubscriptionMetrics: (state) => {
      state.postSubscriptionMetricsLoader = true;
    },
    fetchPostSubscriptionMetrics: (state, action) => {
      state.postSubscriptionMetricsLoader = false;
      state.postSubscriptionMetrics = action.payload;
    },
    getPropertyProductionMetrics: (state) => {
      state.propertyProductionMetricsLoader = true;
    },
    fetchPropertyProductionMetrics: (state, action) => {
      state.propertyProductionMetricsLoader = false;
      state.propertyProductionMetrics = action.payload;
    },
    getSubscriptionRevenueMetrics: (state) => {
      state.subscriptionRevenueMetricsLoader = true;
    },
    fetchSubscriptionRevenueMetrics: (state, action) => {
      state.subscriptionRevenueMetricsLoader = false;
      state.subscriptionRevenueMetrics = action.payload;
    },
    getCustomerExperienceMetrics: (state) => {
      state.customerExperienceMetricsLoader = true;
    },
    fetchCustomerExperienceMetrics: (state, action) => {
      state.customerExperienceMetricsLoader = false;
      state.customerExperienceMetrics = action.payload;
    },
    getSubscriptionModuleFilterData: (state, action) => {
      console.log("AdminDashboard slice", action.payload);
      state.subscriptionModuleFilterData = action.payload;
    },
    getPropertiesFilterData: (state, action) => {
      console.log("AdminDashboard slice", action.payload);
      state.propertiesFilterData = action.payload;
    },
    getUsersModuleFilterData: (state, action) => {
      console.log("AdminDashboard slice", action.payload);
      state.usersModuleFilterData = action.payload;
    },
    getMonitoringPropertiesFilterData: (state, action) => {
      console.log("AdminDashboard slice", action.payload);
      state.monitoringPropertiesFilterData = action.payload;
    },
    clearTempFilterData: (state, action) => {
      state.usersModuleFilterData = {};
      state.subscriptionModuleFilterData = {};
    },
  },
});

export const adminDashboardAction = adminDashboard.actions;
export default adminDashboard.reducer;
